import { render, staticRenderFns } from "./sc-tab.vue?vue&type=template&id=696febec&scoped=true&"
import script from "./sc-tab.vue?vue&type=script&lang=js&"
export * from "./sc-tab.vue?vue&type=script&lang=js&"
import style0 from "./sc-tab.vue?vue&type=style&index=0&id=696febec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696febec",
  null
  
)

export default component.exports